// Libraries
import { FC } from "react";

// Types
import { ModalBodyProps } from "./ModalBody.types";
import { cn } from "utils/cn";

export const ModalBody: FC<ModalBodyProps> = ({
  children,
  className = "",
  containerClassName = "",
  showBorders = false,
  showBottomBorder = true,
  showTopBorder = true,
  layout = "default",
}) => {
  const isPanel = layout === "panel";

  return (
    <div className={cn("flex flex-col gap-4", containerClassName)} data-testid="modal-body">
      {showTopBorder && showBorders && (
        <div
          className="h-px bg-gradient-to-r from-transparent via-border to-transparent"
          data-testid="modal-body-border-top"
        />
      )}
      <div
        className={`flex flex-col justify-center text-left ${
          isPanel
            ? "gap-4 px-4 py-4 text-sm text-foreground"
            : "gap-2 text-regular-3 font-light text-muted-foreground"
        } ${className}`}
      >
        {children}
      </div>
      {showBottomBorder && showBorders && (
        <div
          className="h-px bg-gradient-to-r from-transparent via-border to-transparent"
          data-testid="modal-body-border-bottom"
        />
      )}
    </div>
  );
};

export default ModalBody;
